// Custom icon static resources

import {
  AppstoreOutline,
  ClockCircleOutline,
  CloseOutline,
  CloudServerOutline,
  CodeOutline,
  CrownOutline,
  DownOutline,
  FileSearchOutline,
  InfoCircleOutline,
  LeftOutline,
  RadarChartOutline,
  ReloadOutline,
  RightOutline,
  SafetyCertificateOutline,
  SearchOutline,
  SwapOutline,
  TeamOutline,
  UpOutline
} from '@ant-design/icons-angular/icons';

export const ICONS = [
  AppstoreOutline,
  ClockCircleOutline,
  CloseOutline,
  CloudServerOutline,
  CodeOutline,
  CrownOutline,
  DownOutline,
  FileSearchOutline,
  InfoCircleOutline,
  LeftOutline,
  RadarChartOutline,
  ReloadOutline,
  RightOutline,
  SafetyCertificateOutline,
  SearchOutline,
  SwapOutline,
  TeamOutline,
  UpOutline
];
